import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

// core components
import Button from "../../components/CustomButtons/Button.jsx";
import Add from "@material-ui/icons/Add";
import headerLinksStyle from "../../assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import { hist } from "../../index";

class HeaderLinks extends React.Component {
  state = {};

  backToCategoryList = () => {
    hist.push("/admin/addCategory");
  };

  render() {
    const { classes } = this.props;
    return (
      <div className="header_main_links">
        <div className="new_Card">
          <Button
            color="facebook"
            round
            className={classes.marginRight}
            onClick={this.backToCategoryList}
          >
            <Add className={classes.icons} />
            Add
          </Button>
        </div>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool,
};

export default connect(null)(withStyles(headerLinksStyle)(HeaderLinks));
